import styled from 'styled-components';
import { SCREEN_SIZE } from '../../lib/mediaQuery';

export const PageContent = styled.div`
  > div:nth-child(1) {
    padding-left: 0;
    padding-right: 0;
  }
  @media screen and (max-width: 768px) {
    > div:nth-child(1),
    > div:nth-child(1) > div:nth-child(1),
    > div:nth-child(1) > div:nth-child(2) {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

export const HeaderWrapper = styled.div`
  padding: 0 1rem 1.5rem 0;
  margin-right: auto;
  display: flex;
  &.paymentHeader {
    flex-direction: column;
    padding: 0 0 1.188rem 0;
  }
  .paymentInfoBanner {
    margin-top: 1.5rem;
    ${SCREEN_SIZE.Below.MobileL} {
      margin-top: 0;
    }
  }
  .paymentErrorBanner {
    margin-top: 1.5rem;
    width: 100%;
    background-color: #91082b;
    ._ndsNotificationBanner__content,
    ._ndsNotificationBanner__content > div {
      width: 100%;
      align-items: normal;
    }
    ${SCREEN_SIZE.Below.MobileL} {
      margin-top: 0;
    }
  }
  @media screen and (max-width: 600px) {
    padding: 0 0 24px;
    &.paymentHeader {
      flex-direction: column;
      padding: 0 0 1rem 0;
    }
  }
`;
